export default __webpack_public_path__ + "static/media/ic_cake_40.a983b3d1.svg";